module.exports = __webpack_public_path__ + "static/media/users-icon.616c3970.svg";